export const environment = {
    production: false,
    apiHost: 'https://toyku.luminousz.net/',
    // apiHost: 'https://localhost:4200/',
    lffApps: {
        manageProductAppId: '2000068180-XyWm25Rj',
        watermarkAppId: '2000068180-wYLW39K4',
    },
};
